export interface BaseApiDefinition {
	name: string; // "Name to display" - e.g., "Emails", "Addresses"
	pathSegment: string; // The "changing text in the api part" - e.g., "custsup/email", "addresses/byUser"
}

export const PENDING_WORK = '/api/statistic/custjorfilerowsnotexp'; 	// Returns how many journals or files are pending for work.
export const DISP_JR_FOR_USER = '/api/statistic/jrcfafbc'; 		// Return the number of active journals that are receipts and invoices.
export const DISP_FILE_CLASSIFICATION = '/api/statistic/afdbc'; // Return the number of active files that are grouped by classification for a user.
export const LAST_TIME_DONE_SOME =  '/api/statistic/gldsbc';	// Return the last time something has been done [updload for a file, movein export and last index upload].

// Api to get main data about journals and files.
export const GET_IND_JOR_BY_FILE 	= '/api/dream/jourfile';	// Get the journals of a file by file id.
export const GET_ALL_JOR_BY_CUST	= '/api/dream/journal';		// Get all the journals for a certain customer.
export const GET_FIL_EXPS			= '/api/fe/getex';			// Get file's expenses, not in use [09.08.26]
export const GET_FEATURES_COMP		= '/api/dream/ff';			// Get features for comperason, value and std.value.


export const DICT = '/manage/api/dictionary/'; // Get the dictionary.

export const GET_OPPERATING_USER_NAME = '/api/user/name'; 	// Gets the name of the current operating user.

export const LI 			= '/api/login/'; 		// Stright forword...
export const REFRESH_TOKEN	= '/api/login/refresh'; // Rotates the refresh-token cookie and re-issues the access-token cookie.
export const WHO_AM_I	= '/api/login/me'; // Restores client-side identity from the session cookie alone (no client-supplied id).
export const TWO_FACTOR_STATUS	= '/api/login/2fa/status'; // Read-only check of whether 2FA is enabled for a user.
export const TWO_FACTOR_SETUP	= '/api/login/2fa/setup'; // Starts (or restarts) 2FA enrollment - returns an otpauth:// URI + raw secret.
export const TWO_FACTOR_CONFIRM	= '/api/login/2fa/confirm'; // Confirms enrollment with the first TOTP code.
export const TWO_FACTOR_VERIFY	= '/api/login/2fa/verify'; // Completes a 2FA-gated login: MFA ticket + TOTP code -> session cookies.
export const TWO_FACTOR_DISABLE	= '/api/login/2fa/disable'; // Disables 2FA and clears the stored secret.
export const SET_LANG		= '/api/user/setpreflamg'; // Set language of a user
export const FILE_UPD 		= '/api/inv/uploaddoc';	// Upload files - main file uploader.
export const GET_ALL_JOBS 	= '/api/dream/joball';  // Get all the jobs.

export const ACCOUNT_API_DEFS: BaseApiDefinition[] = [
	{ name: 'Additional Names', pathSegment: 'custsup/addnames' },
	{ name: 'Emails', pathSegment: 'custsup/email' },
	{ name: 'Addresses', pathSegment: 'custsup/addr' },
	{ name: 'Phone Numbers', pathSegment: 'custsup/phone' },
	{ name: 'Payment Info', pathSegment: 'custsup/custpaytype' },
	{ name: 'Relations', pathSegment: 'custsup/relcussup' },
	{ name: 'Move Codes', pathSegment: 'custsup/movecode' },
	{ name: 'Move Code 6111s', pathSegment: 'custsup/movcod6111' },
	{ name: 'URLs', pathSegment: 'custsup/url' },
	{ name: 'Uploades', pathSegment: 'custsup/cusdoc' },
	{ name: 'Profilers', pathSegment: 'custsup/profiler' }

];

export const UPDATE_ACTIVITY: BaseApiDefinition[] =
	[
		{ name: 'TabAdditionalNameComponent', pathSegment: 'custsup/up_cs_addname_act' },
		{ name: 'TabAddressesComponent', pathSegment: 'custsup/up_cs_address_act' },
		{ name: 'TabEmailsComponent', pathSegment: 'custsup/up_cs_email_act' },
		{ name: 'TabMoveCode6111Component', pathSegment: 'custsup/up_cs_movecode6111_act' },
		{ name: 'TabMoveCodesComponent', pathSegment: 'custsup/up_cs_movecode_act' },
		{ name: 'TabPaymentInfoComponent', pathSegment: 'custsup/up_cs_paytype_act' },
		{ name: 'TabPhoneNumbersComponent', pathSegment: 'custsup/up_cs_phone_act' },
		{ name: 'TabRelationsComponent', pathSegment: 'custsup/up_cs_rel_act' },
		{ name: 'TabProfilersComponent', pathSegment: 'custsup/up_profiler_act' },
		{ name: 'TabUrlsComponent', pathSegment: 'custsup/up_cs_url_act' },
		{ name: 'MaintainAccountService', pathSegment: 'custsup/putact'}

	];

export const UPDATE_APPROVED: BaseApiDefinition[] =
	[
		{ name: 'TabAdditionalNameComponent', pathSegment: 'custsup/up_app_cs_addname_act' },
		{ name: 'TabAddressesComponent', pathSegment: 'custsup/up_cs_address_app' },
		{ name: 'TabEmailsComponent', pathSegment: 'custsup/upd_app_cs_email_ui' },
		{ name: 'TabMoveCode6111Component', pathSegment: 'custsup/up_cs_movecode6111_app' },
		{ name: 'TabMoveCodesComponent', pathSegment: 'custsup/up_cs_movecode_app' },
		{ name: 'TabPaymentInfoComponent', pathSegment: 'custsup/up_cs_paytype_app' },
		{ name: 'TabPhoneNumbersComponent', pathSegment: 'custsup/up_cs_phone_app' },
		{ name: 'TabRelationsComponent', pathSegment: 'custsup/up_cs_rel_app' },
		{ name: 'TabProfilersComponent', pathSegment: 'custsup/up_profiler_app' },
		{ name: 'TabUrlsComponent', pathSegment: 'custsup/up_cs_url_app' }
	];


export const CREATE_RECORD: BaseApiDefinition[] =
	[
		{ name: 'AdditionalNamesComponent', pathSegment: 'custsup/ins_cs_addname' },
		{ name: 'AddressesComponent', pathSegment: 'custsup/ins_cs_address' },
		{ name: 'EmailsComponent', pathSegment: 'custsup/ins_cs_email_ui' },
		{ name: 'MoveCode6111Component', pathSegment: 'custsup/ins_cs_movecode6111' },
		{ name: 'MoveCodesComponent', pathSegment: 'custsup/ins_cs_movecode' },
		{ name: 'PaymentInfoComponent', pathSegment: 'custsup/ins_custpaytype' },
		{ name: 'PhoneNumbersComponent', pathSegment: 'custsup/ins_cs_phone' },
		{ name: 'RelationsComponent', pathSegment: 'custsup/ins_cs_rel' },
		{ name: 'ProfilersComponent', pathSegment: 'custsup/ins_profiler' },
		{ name: 'UrlsComponent', pathSegment: 'custsup/ins_cs_url' }
	];

export const UPDATE_RECORD: BaseApiDefinition[] =
	[
		{ name: 'AdditionalNamesComponent', pathSegment: 'custsup/up_cs_addname' },
		{ name: 'AddressesComponent', pathSegment: 'custsup/up_cs_address' },
		{ name: 'EmailsComponent', pathSegment: 'custsup/upd_cs_email_ui' },
		{ name: 'MoveCode6111Component', pathSegment: 'custsup/up_cs_movecode6111' },
		{ name: 'MoveCodesComponent', pathSegment: 'custsup/up_cs_movecode' },
		{ name: 'PaymentInfoComponent', pathSegment: 'custsup/up_cs_paytype' },
		{ name: 'PhoneNumbersComponent', pathSegment: 'custsup/up_cs_phone' },
		{ name: 'RelationsComponent', pathSegment: 'custsup/up_cs_rel' },
		{ name: 'ProfilersComponent', pathSegment: 'custsup/up_profile' },
		{ name: 'UrlsComponent', pathSegment: 'custsup/up_cs_url' }
	];


export const DELETE_RECORD: BaseApiDefinition[] =
	[
		{ name: 'TabAdditionalNameComponent', pathSegment: 'custsup/del_app_cs_addname' },
		{ name: 'TabAddressesComponent', pathSegment: 'custsup/del_cs_address' },
		{ name: 'TabEmailsComponent', pathSegment: 'custsup/del_cs_email' },
		{ name: 'TabMoveCode6111Component', pathSegment: 'custsup/del_cs_movecode6111' },
		{ name: 'TabMoveCodesComponent', pathSegment: 'custsup/del_cs_movecode' },
		{ name: 'TabPaymentInfoComponent', pathSegment: 'custsup/del_cs_paytype' },
		{ name: 'TabPhoneNumbersComponent', pathSegment: 'custsup/del_cs_phone' },
		{ name: 'TabRelationsComponent', pathSegment: 'custsup/del_cs_rel' },
		{ name: 'TabProfilersComponent', pathSegment: 'custsup/del_cs_profile' },
		{ name: 'TabUrlsComponent', pathSegment: 'custsup/del_cs_url' }
	];

export const MAIN_API_DEFS = { ALL_CUST_SUP: 'custsup/all' };

export const DASHBOARD_API_DEFS: BaseApiDefinition[] =
	[
		{ name: 'UploadedFilesWidget', pathSegment: 'statistic/custuploads' },
		{ name: 'UploadedFilesDialog', pathSegment: 'statistic/custuploads' },
		{ name: 'UploadedJournalsWidget', pathSegment: 'statistic/custmovein' },
		{ name: 'UploadedJournalMovesDialogComponent', pathSegment: 'statistic/custmovein' },
		{ name: 'CreatedSuppliersWidget', pathSegment: 'statistic/custsuppliers' },
		{ name: 'UploadedSuppliersDialogComponent', pathSegment: 's	tatistic/custsuppliers' },
	];

export const PHONE_PEF_DEFINERS = '/api/phone/pref'; 	// Returns the prefixes of phones.
export const PHONE_TYP_DEFINERS = '/api/phonetype/get'; // Returns the definers of phones.

// Api for working with index upload.
export const IMPORT_INDEX_LIKE_FILES 	= '/api/ind/upload';
export const INDEX_SECTIONS_DEFINERS 	= '/api/ind/accindsec';
export const INDEX_SECTIONS_DEFINITIONS = '/api/ind/predaccindsec';
export const INDEX_SECTIONS_SUBMIT 		= '/api/ind/upsec';
export const INDEX_RELOAD_REQUEST		= '/api/ind/frip';

// Api for working with index's history.
export const INDEX_HISTORY_LOAD 		= '/api/ind/impindfile';
export const INDEX_HISTORY_ITEM_LOAD 	= '/api/ind/impindfileimpid';
export const INDEX_POSTUPLOAD_REMARKS   = '/api/ind/exloc';
export const INDEX_ASSIGNMENTS_PRINT    = '/api/ind/impsec';


export const LOAD_BUSINESS_TYPE = '/api/bt/get/'; 			// Api to get business type loot.
export const LOAD_ACCOUNTS_TYPE = '/api/custsup/typelist/'; 	// Api to get accounts types.
export const LOAD_ACTIVITY_TYPE = '/api/custsup/cusst/'; 		// Api to get accounts types.
export const CREATE_ACCOUNT     = '/api/custsup/post'; 		// Api to create a supplier or a customer. 

// Api for the document watch (approve) page.
export const LOAD_ALL_FILES = '/api/df/get'; // Api to get the data for the first table.
export const GET_FILE_STATS = '/api/fgc/get' // Api to get all the possible classifications of a file.
export const UPD_FILE_STATS = '/api/fgc/up' // Api to update the classification of a file

// Apis to update FF and JR in eye-dialog
export const EYE_UPDATE_FF = '/api/ff/updpp'; // Updating the FF.
export const EYE_UPDATE_JR = '/api/jor/upd';  // Updating the Journal (JR).

export const UPD_FF_TAB  = '/api/ff/updpp'; // Update ff tab. 
export const UPD_EXP_TAB = '/api/fe/upd';   // Update expense tab.
export const INS_EXP_TAB = '/api/fe/ins';   // Insert expense tab.

export const MOVEIN_HIST = '/api/mi'; // Get movein's api from the history.
export const MOVEIN_DATA = '/api/mi/line' // Get info of the movein's information with jor and file ids.

export const MERGE_FILES = '/api/filemerge/merge'; // Merge files.

export const INPUT_VAT_OPTION = 'custsup/custvatexpnum'; // AutoComplete for Kheshbon_Khova_1 for invoices (Input VAT).
export const SUPPLIER_OPTION  = 'custsup/kkrelcussup'; 	 // AutoComplete for multiple fields, retuens all the related suppliers + "Kupa Ktana".
export const EXPENSE_OPTION   = 'custsup/expenses';		 // AutoComplete for expense's basic info.
export const EXPENSE_LOT_OPTIONS = '/api/cmc6111/get/';  // Also data of expenses.
export const PAYMENT_OPTION   = 'custsup/custpaytype';	 // AutoComplete for payment types.
export const CURRENCY_TYPE 	  = 'ct/get';				 // AutoComplete for currencies.
export const CODETYPE_OPTIONS = ACCOUNT_API_DEFS.find(def => def.name === "Move Codes")?.pathSegment;

export const MPP_RECALC_SUMS = '/api/ff/mpp'; // Function to recalulate the totals with manual post process (MPP).

export const EXPO_MOVEIN_DEF = '/api/movein/exp';

export const LOGIN_LOGOUT_NOTI 	= '/api/login/lo'; // Api to notify the server that user logged out.

export const LOAD_NOTI_FOR_FILE = '/api/fn/fnbyfile'; //Api to load notifications of postprocess for a file.
export const RESOLVE_NOTI_FOR_FILE = '/api/fn/fnir'; // Api to check or uncheck the isResolved Param. 

export const DYNAMIC_MENU = 'api/menu'; // Api to load the side menu, main menu.

export const VAT_FOR_DATE = '/api/inv/vat'; // Api that will return the defined vat rate for a date.

// Workers data apis
export const WORKER_DATA 		= 'api/user/all';  // Api to get all users data.
export const WORKER_ALL_MAILS   = 'api/user/emu';  // Api to get all user's emails.
export const WORKER_ALL_PHONES  = 'api/user/phu';  // Api to get all user's phones.
export const WORKERS_ROLES 		= '/api/role/all'; // Api to get all the roles that either equal to you or under you.

export const WORKER_PHONE_INS = '/api/phus/ins_phus'; 		// Api to insert phone for user.
export const WORKER_PHONE_UPD = '/api/phus/upd_phus'; 		// Api to update phone for user.
export const WORKER_PHONE_SET = '/api/phus/upd_phus_main'; 	// Api to set phone as main.
export const WORKER_PHONE_ACT = '/api/phus/up_phus_act'; 	// Api to set activity to phone.
export const WORKER_PHONE_DEL = '/api/phus/del_phus'; 		// Api to delete phone for user.

export const WORKER_EMAIL_INS = '/api/emus/ins_emus'; 		// Api to insert email for user.
export const WORKER_EMAIL_UPD = '/api/emus/upd_emus';		// Api to updare email for user.
export const WORKER_EMAIL_SET = '/api/emus/upd_emus_main'; 	// Api to set email as main.
export const WORKER_EMAIL_ACT = '/api/emus/up_emus_act'; 	// Api to set activity to email.
export const WORKER_EMAIL_DEL = '/api/emus/del_emus'; 		// Api to delete email for user.

export const WORKER_EMAIL_TKN = '/api/emus/ifexem';			// Api to check if email is already created in the company.
export const WORKER_UNAME_TKN = '/api/user/ifexusnm';		// Api to check if phone is already created in the company.

export const WORKER_REASSIGN = '/api/uscu/upd'; // Api to re-assign customer from worker to worker.

export const WORKER_INS = '/api/user/ins'; // Api to create a new worker.
export const WORKER_UPD = '/api/user/up';  // Api to update worker's data.s
export const WORKER_GTP = '/api/user/tp';  // Api to get worker's temporal password.


// Select customer and company apis.
export const CUSTOMERS_OF_WORKER = '/api/custsup/custsuser'; 		// Api to get all the customer that has been assigned.
export const COMPANIES_OF_WORKER = '/api/company/getcompbyuser'; 	// Api to get the assigned company of the user.

export const FILE_GROUPS_GRADE = '/api/fgmsg/ffgg'; // Api to get detailed grades for each file.
export const FILE_GRADE_REPORT = '/api/fgmsg/get';  // Api to get the grades for all the FFs.

export const LST_OF_COUNTRIES = '/api/country/country';  // Api to get list of countries.
export const LST_OF_ADDR_TYPE = '/api/addrtype/get'; 	 // Api to get list of address types.
export const LST_OF_CITY_IN_COUNTRY = '/api/city/get'; 	 // Api to get all cities in some country.
export const LST_OF_STREETS_IN_CITY = '/api/street/get'; // Api to get all streets in some city.


export const COMP_MC6111 = '/api/category6111/get';  // Api to get the loot of mc6111.
export const COMP_MC	 = '/api/custsup/movecode/'; // Api to get the loot of move codes.
export const COMP_PROFILES = '/api/profile/get'; 	 // Api to get the loot of profiles.

export const LOT_PAYMENT_TYPE   = '/api/paymtype/getdd'; 		// Api to get data of payment types.
export const LOT_BANK_NAMES		= '/api/bank/get';		 		// Api to get data of all the possible banks.
export const LOT_CREDIT_TYPES	= '/api/creditcardtype/getdd';  // Api to get credit card types.
export const LOT_PHONE_PREFS	= '/api/phone/pref';			// Api to get phone prefixes.
export const LOT_PHONE_TYPES	= '/api/phonetype/get';			// Api to get phone types.


// Landing related
export const ORDER_DEMO = '/api/c2us/c'
